import { Fragment, useState } from 'react';

import { dpr } from 'Utils/dpr';

import { IProductInfo } from 'Types/Litium';
import DividerWide from 'Components/DividerWide';
import DropdownArrow from 'Components/DropDownArrow';
import Markup from 'Components/Markup';

const Accordion = ({ productData }: { productData: IProductInfo[] }) => {
    const [openIndex, setOpenIndex] = useState(0);
    const toggleAccordion = (index: number) => {
        setOpenIndex(prevOpenIndex => (prevOpenIndex === index ? -1 : index));
    };

    const productDataHasContent = productData.filter(
        item =>
            (item.description && item.description.length > 0) ||
            (item.productInfoList && item.productInfoList.length > 0)
    );

    return (
        <ul className="grid w-full grid-cols-1 justify-center">
            {productDataHasContent.map((item, index) => (
                <Fragment key={index}>
                    <li aria-hidden="true">
                        <DividerWide />
                    </li>
                    <li className="my-5">
                        <button
                            aria-controls={`product-info-accordion-${index}`}
                            aria-expanded={
                                index === openIndex ? 'true' : 'false'
                            }
                            onClick={() => toggleAccordion(index)}
                            className="flex w-full items-center justify-between font-montserrat text-sm leading-normal text-black lg:text-base"
                        >
                            <span className="flex content-center">
                                <span className="flex h-5 w-5 items-center lg:h-8 lg:w-8">
                                    <img
                                        src={`${item.icon.src}?format=webp&height=32&width=32`}
                                        srcSet={dpr(
                                            `${item.icon.src}?format=webp&height=32&width=32`
                                        )}
                                        alt={item.icon.altText}
                                        width="32"
                                        height="32"
                                    />
                                </span>
                                {item.title && (
                                    <span className="ml-2 self-center font-roboto">
                                        {item.title}
                                    </span>
                                )}
                            </span>
                            <span className="flex h-8 w-8 items-center justify-center">
                                <span className="block h-4 w-4">
                                    <DropdownArrow
                                        showPlus={index === openIndex}
                                    />
                                </span>
                            </span>
                        </button>
                        <div
                            className={`grid overflow-hidden transition-[grid-template-rows] duration-layout ${
                                index === openIndex
                                    ? 'visible grid-rows-[1fr]'
                                    : 'grid-rows-[0fr]'
                            } visible`}
                            id={`product-info-accordion-${index}`}
                        >
                            <ul
                                className={`overflow-hidden transition-[grid-template-rows] duration-layout ${
                                    index === openIndex
                                        ? 'visible'
                                        : 'invisible'
                                } lg:visible`}
                            >
                                <li className="py-5">
                                    {item.description && (
                                        <Markup
                                            html={item.description}
                                            as="div"
                                            cssClass="mb-5 leading-6"
                                        />
                                    )}
                                    {item.productInfoList && (
                                        <table className="w-full">
                                            <tbody>
                                                {item.productInfoList.map(
                                                    (subItem, subIndex) => (
                                                        <tr
                                                            className="border-b border-t"
                                                            key={`productInfoList-${subIndex}`}
                                                        >
                                                            <td className="py-2 font-roboto font-medium">
                                                                {subItem.title}
                                                            </td>
                                                            <td
                                                                className={`py-2 text-right font-roboto ${
                                                                    index === 0
                                                                        ? 'capitalize'
                                                                        : ''
                                                                }`}
                                                            >
                                                                {index === 0
                                                                    ? subItem.value.toLowerCase()
                                                                    : subItem.value}
                                                            </td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    )}
                                </li>
                            </ul>
                        </div>
                    </li>
                </Fragment>
            ))}
        </ul>
    );
};

export default Accordion;
